import type { ImgHTMLAttributes } from "react"

export default function AppLogoIcon(
  props: ImgHTMLAttributes<HTMLImageElement>,
) {
  return <img src="/icon.png" alt="ThaiCopilot" className="h-8" {...props} />
}
